// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { create } from 'zustand'

interface SyncState {
  pendingCount: number
  failedCount:  number
  isOnline:     boolean
  lastSyncedAt: string | null

  // Actions
  updateStatus: (status: {
    pendingCount?: number
    failedCount?:  number
    lastSyncedAt?: string
  }) => void
  setOnline: (online: boolean) => void
}

export const useSyncStore = create<SyncState>((set) => ({
  pendingCount: 0,
  failedCount:  0,
  isOnline:     navigator.onLine,
  lastSyncedAt: null,

  updateStatus: (status) =>
    set((state) => ({ ...state, ...status })),

  setOnline: (online) =>
    set({ isOnline: online }),
}))

// Listen to online/offline events
if (typeof window !== 'undefined') {
  window.addEventListener('online',  () => useSyncStore.getState().setOnline(true))
  window.addEventListener('offline', () => useSyncStore.getState().setOnline(false))
}
